module.exports = __webpack_public_path__ + "img/599_0.82f41473.png";